import 'react-datepicker/dist/react-datepicker.css';

import DatePicker from 'react-datepicker';

interface DateTimeChooserProps {
  value: Date;
  onChange: (date: Date) => void;
}

export const DateTimeChooser = ({ value, onChange }: DateTimeChooserProps) => {
  return (
    <div className="flex items-center space-x-2">
      <DatePicker
        selected={value}
        onChange={(date) => onChange(date || new Date())}
        showTimeSelect
        dateFormat="MMMM d, yyyy h:mm aa"
        className="block rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500 px-4 py-2.5"
        placeholderText="Select date and time"
      />
    </div>
  );
};
